import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
export const SameWordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
   const password = control.get("password");
   const repeatPassword = control.get("repeatPassword");
   return password && repeatPassword && password.value !== repeatPassword.value ? { differentPassword: true } : null;
};
